export default __webpack_public_path__ + "static/media/gallery_02.5fcdd4db.jpg";